import { render, staticRenderFns } from "./offeringsList.vue?vue&type=template&id=3e71de26&scoped=true&"
import script from "./offeringsList.vue?vue&type=script&lang=js&"
export * from "./offeringsList.vue?vue&type=script&lang=js&"
import style0 from "./offeringsList.vue?vue&type=style&index=0&id=3e71de26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e71de26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e71de26')) {
      api.createRecord('3e71de26', component.options)
    } else {
      api.reload('3e71de26', component.options)
    }
    module.hot.accept("./offeringsList.vue?vue&type=template&id=3e71de26&scoped=true&", function () {
      api.rerender('3e71de26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/deceased/enshrineList/offeringsList.vue"
export default component.exports